import { authTypeSchema } from "@packsize/schemas";
import { z } from "zod";

export const ssoFailureReasonSchema = z.enum([
	"No Roles Provided",
	"IdP Site Not Found",
	"Not all sites are part of the company",
	"No SAML attribute values matched",
	"User Not Found",
	"no-token",
	"invalid-token",
	"timeout",
	"unknown",
]);

export const ssoFailureDtoSchema = z
	.object({
		reason: ssoFailureReasonSchema.catch("unknown"),
		idToken: z.string().nullish(),
		referenceId: z.string(),
		authType: authTypeSchema,
	})
	.catch({
		reason: "unknown",
		idToken: null,
		referenceId: "",
		authType: {
			id: 2,
			name: "Saml",
		},
	});

export type SsoFailureDto = z.infer<typeof ssoFailureDtoSchema>;
export type SsoFailureReason = z.infer<typeof ssoFailureReasonSchema>;
